import { Box, Button, Stack } from '@mui/material';
import { USER_TYPES } from '../../config/dataService/constants';

const styles = {
    footer: {
        padding: '16px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #E0E0E0!important',
        bgcolor: '#fff',
        borderRadius: '0px 0px 8px 8px',
        flexShrink: 0,
    },
    addDetailsBtn: {
        backgroundColor: '#EEEEEE',
        color: 'rgba(0, 0, 0, 0.87)',
        textTransform: 'uppercase',
        boxShadow: 'none',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: '#E0E0E0',
            boxShadow: 'none',
        },
    },
    cancelBtn: {
        textTransform: 'uppercase',
        fontWeight: 500,
        // color: 'rgba(0, 0, 0, 0.87)',
        '&:hover': {
            // borderColor: 'rgba(0, 0, 0, 0.87)',
            // backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    nextBtn: {
        textTransform: 'uppercase',
        fontWeight: 500,
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        },
    },
};

const ModalFooter = ({ customerType, onDelete, onClose, onNext, onBack, activeStep, steps, isLoading = false, fromProfile = false, isEditMode = false }) => {
    const showDeleteButton = customerType === USER_TYPES.SHOP_IMPORTED || (fromProfile && customerType === USER_TYPES.SHOP_CREATED);

    return (
        <Box sx={styles.footer}>
            <Box>
                {showDeleteButton && (
                    <Button
                        color="error"
                        variant="contained"
                        backgroundColor="#fff"
                        onClick={fromProfile ? onDelete : onClose}
                        sx={styles.cancelBtn}
                        disabled={isLoading}
                    >
                        {fromProfile ? 'Delete' : 'Cancel'}
                    </Button>
                )}

                {!isEditMode && customerType === USER_TYPES.SHOP_CREATED && (
                    <Button color="error" variant="contained" backgroundColor="#fff" onClick={onClose} sx={styles.cancelBtn} disabled={isLoading}>
                        Cancel
                    </Button>
                )}
            </Box>

            <Stack direction="row" spacing={2}>
                {activeStep > 0 && !isEditMode && (
                    <Button variant="outlined" onClick={onBack} sx={styles.cancelBtn} disabled={isLoading}>
                        Back
                    </Button>
                )}
                {isEditMode && (
                    <Button variant="outlined" onClick={onClose} sx={styles.cancelBtn} disabled={isLoading}>
                        Cancel
                    </Button>
                )}
                <Button variant="contained" onClick={onNext} sx={styles.nextBtn} disabled={isLoading}>
                    {activeStep === steps.length - 1 || isEditMode ? 'Save' : 'Next'}
                </Button>
            </Stack>
        </Box>
    );
};

export default ModalFooter;
